
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Noch ist der Schweizer Wald generell in gutem Zustand und hat in den letzten Jahren punkto Artenvielfalt sogar zugelegt. Aber er gerät wegen des Klimawandels unter Druck: Zu diesem Schluss kommt auch der Bund in seinem neusten `}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/seine-vielfalt-macht-den-schweizer-wald-staerker-598923019912https://www.tagesanzeiger.ch/seine-vielfalt-macht-den-schweizer-wald-staerker-598923019912"
      }}>{`Waldbericht`}</a>{`. Demnach haben sich Perioden mit grosser Waldbrandgefahr verlängert. Aufgrund der Erwärmung ist der Holzvorrat an Nadelhölzern wie der Fichte im Mittelland rückläufig. Und das Risiko, dass sich Wärme liebende Schädlinge im Schweizer Wald verbreiten, steigt.`}</p>
    <p>{`Was kann man gegen diese Entwicklung tun? Laut Gessler sollte man Mischwälder fördern, wie das in der Schweiz schon stark gemacht wird. «Das hat den Effekt, dass sich verschiedene Bäume gegenseitig unterstützen, zum Beispiel wenn ihre Wurzeln unterschiedlich tief reichen und sie sich so gegenseitig kein Wasser wegnehmen», erklärt der WSL-Forscher. `}</p>
    <p>{`Eine Chance ist auch die Förderung von Baumarten, die während den Trockenperioden weniger leiden als andere. Die Eiche so eine Kandidatin. Eingeführte Baumarten wie die Douglasie, die Grosse Küstentanne oder die Orientbuche könnten sich ebenfalls anbieten. Doch die Frage, welche Baumart sich in einem wärmeren und trockeneren Klima in Zukunft behaupten wird und holzwirtschaftlich einen genügend grossen Ertrag abwirft, sei nach wie vor offen, schreiben die Autoren des Waldberichts.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;